module.exports = __webpack_public_path__ + "static/media/6en.a6868d1e.jpg";